webpackJsonp([1],{

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "2uFj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  COSMIC_BUCKET: "melg-festas",
  COSMIC_READ_KEY: "skXyPHTE5EuZBJZLHLVPpgdQD8U66XKJB47JizVvE9zE7rbVuB",
  COSMIC_WRITE_KEY: "OU16skvgcl14cR3A9AszDyOPsZAepjiEBEE7x1hMNyV7vEDRqL",
  BLOG_TITLE: "Melg Festas"
});

/***/ }),

/***/ "2x06":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers__ = __webpack_require__("cX0o");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'blog-feed',
  resource: 'BlogFeed',

  props: {
    filters: {
      type: Object,
      default: function _default() {}
    }
  },

  data: function data() {
    return {
      posts: [],
      transition: 'preview-appear'
    };
  },


  computed: {
    reading: function reading() {
      return this.filters.post;
    },
    scrollDelay: function scrollDelay() {
      return this.$device.phone ? 0 : 560;
    },
    figureClass: function figureClass() {
      return { 'preview__figure--mobile': this.$device.phone && this.reading };
    },
    feed: function feed() {
      var _this = this;

      var filterBy = {
        post: function post(filter, _ref) {
          var id = _ref.id;
          return filter === id;
        },
        author: function author(filter, _ref2) {
          var _author = _ref2.author;
          return filter === _this.kebabify(_author);
        }
      };

      if (!__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.filters).length) return this.posts;

      return this.posts.filter(function (post) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_this.filters).every(function (filter) {
          return filterBy[filter](_this.filters[filter], post);
        });
      });
    }
  },

  methods: {
    scrollTo: __WEBPACK_IMPORTED_MODULE_1__helpers__["c" /* scrollTo */],
    kebabify: __WEBPACK_IMPORTED_MODULE_1__helpers__["a" /* kebabify */],
    prettyDate: __WEBPACK_IMPORTED_MODULE_1__helpers__["b" /* prettyDate */],
    getBgImg: function getBgImg(src) {
      return { backgroundImage: 'url(' + src + ')' };
    },
    stackPosts: function stackPosts(posts) {
      var _this2 = this;

      var interval = void 0;
      var stack = function stack() {
        _this2.posts.push(posts.shift());

        if (!posts.length) {
          _this2.transition = 'preview';
          clearInterval(interval);
        }
      };

      interval = setInterval(stack, 125);
    }
  },

  beforeMount: function beforeMount() {
    var _this3 = this;

    this.$getResource('feed').then(function (posts) {
      if (!__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_this3.filters).length) {
        _this3.stackPosts(posts);
      } else {
        _this3.posts = posts;
        _this3.transition = 'preview';
      }
    });
  }
});

/***/ }),

/***/ "33RP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"appear":"","name":"v--mask"}},[_vm._m(0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"blog__footer"},[_c('div',{staticClass:"signature cosmicjs"},[_vm._v("\n      Proudly powered by "),_c('a',{attrs:{"href":"https://cosmicjs.com","target":"_blank"}},[_vm._v("Cosmic JS")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6Lyb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({ name: 'blog-footer' });

/***/ }),

/***/ "9k9s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Blog__ = __webpack_require__("eJ85");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Blog", function() { return __WEBPACK_IMPORTED_MODULE_0__Blog__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BlogFeed__ = __webpack_require__("bksL");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BlogFeed", function() { return __WEBPACK_IMPORTED_MODULE_1__BlogFeed__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BlogPost__ = __webpack_require__("rcwA");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BlogPost", function() { return __WEBPACK_IMPORTED_MODULE_2__BlogPost__["a"]; });




/***/ }),

/***/ "CFwd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"post"}},[(_vm.post)?_c('article',{staticClass:"post"},[_c('header',{staticClass:"post__header"},[_c('h2',{staticClass:"post__title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('h3',{staticClass:"post__meta"},[_vm._v("by "),_c('router-link',{staticClass:"post__author",attrs:{"to":("/by/" + (_vm.kebabify(_vm.author)))}},[_vm._v(_vm._s(_vm.author))]),_vm._v(" "),_c('span',{staticClass:"post__sep"}),_vm._v(" "),_c('time',[_vm._v(_vm._s(_vm.prettyDate(_vm.published)))])],1),_vm._v(" "),_c('blockquote',{staticClass:"post__subtitle"},[_vm._v(_vm._s(_vm.description))])]),_vm._v(" "),_c('section',{staticClass:"post__body rte",domProps:{"innerHTML":_vm._s(_vm.content)}}),_vm._v(" "),_c('footer',{staticClass:"post__footer"},[(_vm.commentsReady)?_c('vue-disqus',{key:_vm.post,attrs:{"shortname":"vue-blog-demo","identifier":_vm.post,"url":("https://vue-blog-demo.netlify.com/read/" + _vm.post)}}):_vm._e()],1)]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CHQz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BlogTitle__ = __webpack_require__("S2Ar");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BlogNav__ = __webpack_require__("y7Eb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BlogFeed__ = __webpack_require__("xdpD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BlogPost__ = __webpack_require__("InHs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BlogFooter__ = __webpack_require__("kYEd");
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'blog',
  components: { BlogTitle: __WEBPACK_IMPORTED_MODULE_0__BlogTitle__["a" /* default */], BlogNav: __WEBPACK_IMPORTED_MODULE_1__BlogNav__["a" /* default */], BlogFeed: __WEBPACK_IMPORTED_MODULE_2__BlogFeed__["a" /* default */], BlogPost: __WEBPACK_IMPORTED_MODULE_3__BlogPost__["a" /* default */], BlogFooter: __WEBPACK_IMPORTED_MODULE_4__BlogFooter__["a" /* default */] },
  resource: 'Blog',
  props: {
    post: String,
    author: String
  },

  data: function data() {
    return {
      navs: 0,
      title: '',
      labels: {
        post: '',
        author: ''
      }
    };
  },


  computed: {
    content: function content() {
      return { title: this.title, labels: this.labels };
    },
    filters: function filters() {
      var filters = {};

      if (this.post) filters.post = this.post;
      if (this.author) filters.author = this.author;

      return filters;
    }
  },

  watch: {
    '$route.name': function $routeName(to, from) {
      if (to !== from) this.navs++;
    }
  },

  beforeMount: function beforeMount() {
    this.$getResource('blog');
  }
});

/***/ }),

/***/ "Dk1v":
/***/ (function(module, exports) {

module.exports = {"_args":[["scrollto-with-animation@4.5.2","/opt/build/repo"]],"_from":"scrollto-with-animation@4.5.2","_id":"scrollto-with-animation@4.5.2","_inBundle":false,"_integrity":"sha1-WoS10aHtlDvlRiVULXcxk9bBGd4=","_location":"/scrollto-with-animation","_phantomChildren":{},"_requested":{"type":"version","registry":true,"raw":"scrollto-with-animation@4.5.2","name":"scrollto-with-animation","escapedName":"scrollto-with-animation","rawSpec":"4.5.2","saveSpec":null,"fetchSpec":"4.5.2"},"_requiredBy":["/"],"_resolved":"https://registry.npmjs.org/scrollto-with-animation/-/scrollto-with-animation-4.5.2.tgz","_spec":"4.5.2","_where":"/opt/build/repo","author":{"name":"David Sancho","email":"dsnxmoreno@gmail.com","url":"https://github.com/davesnx"},"bugs":{"url":"https://github.com/davesnx/scrollto-with-animation/issues"},"dependencies":{"animation-frame":"^0.3.0"},"description":"Animated Scroll with requestAnimationFrame. For smooth animate scrollTo defining the easing, running at 60FPS and cross-browser","devDependencies":{"babel-cli":"^6.9.0","babel-loader":"^6.2.2","babel-preset-es2015":"^6.3.13","babel-preset-stage-2":"^6.3.13","jasmine-core":"^2.3.4","json-loader":"^0.5.4","karma":"^0.13.9","karma-chrome-launcher":"^0.2.1","karma-cli":"0.1.0","karma-coverage":"^0.5.3","karma-jasmine":"^0.3.6","karma-phantomjs-launcher":"^0.2.1","karma-sourcemap-loader":"^0.3.6","karma-spec-reporter":"0.0.22","karma-story-reporter":"^0.3.1","karma-webpack":"^1.7.0","phantomjs":"^1.9.18","pre-push":"^0.1.1","webpack":"^1.12.13"},"files":["src","lib","dist","README.md"],"homepage":"https://github.com/davesnx/scrollto-with-animation#readme","keywords":["animation","scrollTo","60fps","cross-browser","requestAnimationFrame","easeInQuad","browserify"],"license":"MIT","main":"lib/index.js","name":"scrollto-with-animation","pre-commit":["test"],"repository":{"type":"git","url":"git+https://github.com/davesnx/scrollto-with-animation.git"},"scripts":{"build":"npm run clean && npm run compile:prod && npm run minify:prod","clean":"rm -rf dist/* && rm -rf lib/","compile:dev":"NODE_ENV=dev babel src --watch --out-dir lib","compile:prod":"NODE_ENV=prod babel src --out-dir lib","minify:dev":"NODE_ENV=dev webpack --watch","minify:prod":"NODE_ENV=prod webpack -p","prepublish":"npm run build","test":"NODE_ENV=prod karma start test/karma.config.js --single-run","test:dev":"NODE_ENV=prod karma start test/karma.config.js --auto-watch"},"standard":{"parser":"babel-eslint","global":["jasmine","it","describe","beforeEach","afterEach","expect","spyOn"]},"version":"4.5.2"}

/***/ }),

/***/ "E7C/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_disqus_VueDisqus__ = __webpack_require__("d9EC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers__ = __webpack_require__("cX0o");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'blog-post',
  resource: 'BlogPost',
  components: { VueDisqus: __WEBPACK_IMPORTED_MODULE_0_vue_disqus_VueDisqus__["a" /* default */] },
  props: { post: String },

  data: function data() {
    return {
      title: '',
      author: '',
      content: '',
      published: '',
      description: '',
      commentsReady: false
    };
  },


  watch: {
    post: function post(to, from) {
      if (to === from || !this.post) return;

      this.commentsReady = false;
      this.$getResource('post', to).then(this.showComments);
    }
  },

  methods: {
    kebabify: __WEBPACK_IMPORTED_MODULE_1__helpers__["a" /* kebabify */],
    prettyDate: __WEBPACK_IMPORTED_MODULE_1__helpers__["b" /* prettyDate */],
    showComments: function showComments() {
      var _this = this;

      setTimeout(function () {
        _this.commentsReady = true;
      }, 1000);
    }
  },

  beforeMount: function beforeMount() {
    if (!this.post) return;
    this.$getResource('post', this.post).then(this.showComments);
  }
});

/***/ }),

/***/ "InHs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BlogPost_vue__ = __webpack_require__("E7C/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c1c889be_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BlogPost_vue__ = __webpack_require__("CFwd");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BlogPost_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c1c889be_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BlogPost_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "LNky":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-view',{attrs:{"id":"app"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_427a9fc7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("LNky");
function injectStyle (ssrContext) {
  __webpack_require__("UsXZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_427a9fc7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MdQY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return matchMedia; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);


var matchMediaFallback = function matchMediaFallback() {
  var listeners = [];
  var idle = true;

  var device = function () {
    var node = document.createElement('div');
    var style = document.createElement('style');

    node.id = 'match-media-node';
    style.innerHTML = '#match-media-node {\n      width: 100%;\n      height: 100%;\n      position: absolute;\n      bottom: 100%;\n      overflow: scroll;\n    }';

    document.head.appendChild(style);
    document.body.insertBefore(node, document.body.children[0]);

    return {
      get width() {
        return node.clientWidth;
      },
      get height() {
        return node.clientHeight;
      },
      get orientation() {
        return node.clientHeight > node.clientWidth ? 'portrait' : 'landscape';
      },
      get fontSize() {
        return window.getComputedStyle(document.documentElement).getPropertyValue('font-size');
      }
    };
  }();

  var createHandler = function createHandler(feature, value) {
    if (feature === 'orientation') {
      return function () {
        return value === device.orientation;
      };
    }

    var _feature$split$revers = feature.split('-').reverse(),
        _feature$split$revers2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_feature$split$revers, 2),
        prop = _feature$split$revers2[0],
        limit = _feature$split$revers2[1];

    var operand = !limit ? '==' : limit === 'min' ? '<' : '>';

    var parseValue = function () {
      return ~value.indexOf('em') ? function () {
        return parseFloat(value) * device.fontSize;
      } : function () {
        return parseFloat(value);
      };
    }();

    var handlers = {
      'width': function width() {
        return eval(parseValue() + operand + device.width);
      },
      'height': function height() {
        return eval(parseValue() + operand + device.height);
      }
    };

    return handlers[prop];
  };

  var parseQuery = function parseQuery(queryString) {
    var _queryString$replace$ = queryString.replace(/[()\s]/g, '').split(':'),
        _queryString$replace$2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_queryString$replace$, 2),
        feature = _queryString$replace$2[0],
        value = _queryString$replace$2[1];

    return createHandler(feature, value);
  };

  window.addEventListener('resize', function () {
    if (!idle) return;
    idle = false;

    var width = device.width;
    var height = device.height;

    var timer = setInterval(function () {
      if (width !== device.width || height !== device.height) {
        width = device.width;
        height = device.height;
      } else {
        clearTimeout(timer);
        listeners.forEach(function (handler) {
          return handler();
        });
        idle = true;
      }
    }, 100);
  });

  return function (queryString) {
    var query = parseQuery(queryString);
    var matcher = {
      get matches() {
        return query();
      }
    };

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, matcher, {
      addListener: function addListener(cb) {
        var handler = function handler() {
          return cb(matcher);
        };
        listeners.push(handler);
      }
    });
  };
};

var matchMedia = window.matchMedia || matchMediaFallback();



/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__startup__ = __webpack_require__("is/7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__resources__ = __webpack_require__("9k9s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__plugins_resource__ = __webpack_require__("cb2V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__plugins_device_queries__ = __webpack_require__("uJQI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config__ = __webpack_require__("2uFj");










__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5__plugins_resource__["a" /* default */], {
  resources: __WEBPACK_IMPORTED_MODULE_4__resources__,
  endpoint: 'https://api.cosmicjs.com/v1/' + __WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].COSMIC_BUCKET
});

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6__plugins_device_queries__["a" /* default */], {
  phone: 'max-width: 567px',
  tablet: 'min-width: 568px',
  mobile: 'max-width: 1024px',
  laptop: 'min-width: 1025px',
  desktop: 'min-width: 1280px',
  monitor: 'min-width: 1448px'
});

new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */]);
  }
}).$mount('#app');

/***/ }),

/***/ "S2Ar":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BlogTitle_vue__ = __webpack_require__("ciEr");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */
var __vue_template__ = null
/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BlogTitle_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "SGec":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Blog_vue__ = __webpack_require__("CHQz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_484d4a3e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Blog_vue__ = __webpack_require__("a8u0");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Blog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_484d4a3e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Blog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UsXZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WYec":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);


/* harmony default export */ __webpack_exports__["a"] = ((function () {
  var store = {};

  return {
    has: function has(uri) {
      return !!store[uri];
    },
    get: function get(uri) {
      return JSON.parse(store[uri]);
    },
    set: function set(uri, data) {
      store[uri] = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(data);
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(data);
    }
  };
})());

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components__ = __webpack_require__("bGai");




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  linkActiveClass: 'active',
  routes: [{
    path: '/',
    name: 'feed',
    component: __WEBPACK_IMPORTED_MODULE_2__components__["a" /* default */]
  }, {
    path: '/by/:author',
    name: 'author',
    props: true,
    component: __WEBPACK_IMPORTED_MODULE_2__components__["a" /* default */]
  }, {
    path: '/read/:post',
    name: 'post',
    props: true,
    component: __WEBPACK_IMPORTED_MODULE_2__components__["a" /* default */]
  }]
}));

/***/ }),

/***/ "a8u0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"blog",class:{ 'blog--reading': this.post }},[_c('blog-title',{attrs:{"blog-name":_vm.title,"filters":_vm.filters}}),_vm._v(" "),_c('blog-nav',{attrs:{"content":_vm.content,"filters":_vm.filters,"navs":_vm.navs}}),_vm._v(" "),_c('blog-feed',{attrs:{"filters":_vm.filters}}),_vm._v(" "),_c('blog-post',{attrs:{"post":_vm.post}}),_vm._v(" "),_c('blog-footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bGai":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Blog__ = __webpack_require__("SGec");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Blog__["a"]; });


/***/ }),

/***/ "bksL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_map__ = __webpack_require__("MByf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_map__);


/* harmony default export */ __webpack_exports__["a"] = ({
  feed: function feed() {
    return {
      path: '/object-type/posts',
      resolve: function resolve(response, mappers) {
        var _posts = __WEBPACK_IMPORTED_MODULE_0_lodash_map___default()(response.objects, function (i) {
          var temp = {
            title: i.title,
            image: i.metadata.image.imgix_url,
            published: i.created_at,
            author: i.metadata.author.title,
            id: i.slug
          };
          return temp;
        });
        return mappers.pipe(_posts);
      }
    };
  }
});

/***/ }),

/***/ "cX0o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return scrollTo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return kebabify; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return unkebabify; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return prettyDate; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_scrollto_with_animation__ = __webpack_require__("M75F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_scrollto_with_animation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_scrollto_with_animation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_capitalize__ = __webpack_require__("MxEV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_capitalize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_capitalize__);




var scrollTo = function scrollTo(pos) {
  var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 600;
  var delay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
    setTimeout(function () {
      __WEBPACK_IMPORTED_MODULE_1_scrollto_with_animation___default()(document.documentElement, 'scrollTop', pos, duration, 'easeInOutSine', resolve);
    }, delay);
  });
};

var kebabify = function kebabify(words) {
  return words.toLowerCase().replace(' ', '-');
};

var unkebabify = function unkebabify(str) {
  return __WEBPACK_IMPORTED_MODULE_2_capitalize___default.a.words(str.replace(/-/g, ' '));
};

var prettyDate = function prettyDate(date) {
  return new Date(date).toString().split(' ').slice(0, 4).join(' ').replace(/( \d+)$/, ',$1');
};

/***/ }),

/***/ "cb2V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cache__ = __webpack_require__("WYec");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_merge__ = __webpack_require__("mB6w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_merge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_merge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__("2uFj");






// install $resource as a Vue plugin
/* harmony default export */ __webpack_exports__["a"] = ({
  install: function install(Vue, _ref) {
    var _ref$endpoint = _ref.endpoint,
        endpoint = _ref$endpoint === undefined ? '' : _ref$endpoint,
        _ref$resources = _ref.resources,
        resources = _ref$resources === undefined ? {} : _ref$resources;

    Vue.prototype.$getResource = function (method, options) {
      var _this = this;

      var name = this.$options.resource;
      if (!name || !resources[name] || !resources[name][method]) return;

      // get fetch path and response resolver/mapper

      var _resources$name$metho = resources[name][method](options),
          path = _resources$name$metho.path,
          resolve = _resources$name$metho.resolve;

      var uri = '';
      if (method === 'blog') {
        uri = '/static/api' + path;
      } else {
        uri = endpoint + path + '?hide_metafields=true&read_key=' + __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].COSMIC_READ_KEY;
      }

      // methods return promise to allow chaining
      var mappers = {
        // only return promise without modifying instance $data
        pipe: function pipe(dataSet) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(dataSet);
        },

        // deep merge object with instance $data
        merge: function merge(dataSet) {
          __WEBPACK_IMPORTED_MODULE_3_lodash_merge___default()(_this.$data, dataSet);
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(dataSet);
        },

        // set individual props on instance $data
        set: function set(dataSet) {
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(dataSet).forEach(function (prop) {
            _this.$set(_this.$data, prop, dataSet[prop]);
          });

          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(dataSet);
        }

        // check to see if the resource has been cached already
      };if (__WEBPACK_IMPORTED_MODULE_2__cache__["a" /* default */].has(uri)) return resolve(__WEBPACK_IMPORTED_MODULE_2__cache__["a" /* default */].get(uri), mappers);

      // fetch, parse and cache resource then pass to resolver
      return fetch(uri).then(function (response) {
        return response.json();
      }).then(function (response) {
        return __WEBPACK_IMPORTED_MODULE_2__cache__["a" /* default */].set(uri, response);
      }).then(function (response) {
        return resolve(response, mappers);
      });
    };
  }
});

/***/ }),

/***/ "ciEr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers__ = __webpack_require__("cX0o");



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'blog-title',
  props: ['blogName', 'filters'],

  data: function data() {
    return {
      subTitle: ''
    };
  },


  computed: {
    title: function title() {
      if (this.filters.post) return this.subTitle + ' - Post';
      if (this.filters.author) return this.subTitle + ' - Author';
      return 'Feed - ' + this.blogName;
    }
  },

  methods: {
    setSubTitle: function setSubTitle(payload) {
      this.subTitle = Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["d" /* unkebabify */])(payload);
    }
  },

  watch: {
    title: function title() {
      document.title = this.title;
    },
    '$route.params': function $routeParams(params) {
      if (params.post) this.setSubTitle(params.post);
      if (params.author) this.setSubTitle(params.author);
    }
  },

  created: function created() {
    document.title = this.title;
  },
  beforeMount: function beforeMount() {
    var params = this.$route.params;
    if (params.post) this.setSubTitle(params.post);
    if (params.author) this.setSubTitle(params.author);
  },
  render: function render() {}
});

/***/ }),

/***/ "d9EC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VueDisqus_vue__ = __webpack_require__("gNKr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_611a2994_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_VueDisqus_vue__ = __webpack_require__("lsTR");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VueDisqus_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_611a2994_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_VueDisqus_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eJ85":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__("2uFj");


/* harmony default export */ __webpack_exports__["a"] = ({
  blog: function blog() {
    return {
      path: '/blog.json',
      resolve: function resolve(response, mappers) {
        var blog = response.results[0];
        return mappers.merge({
          title: __WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */].BLOG_TITLE || blog.title,
          labels: {
            post: blog.post_label,
            author: blog.author_label
          }
        });
      }
    };
  }
});

/***/ }),

/***/ "gNKr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vue-disqus',
  props: {
    shortname: {
      type: String,
      required: true
    },
    identifier: {
      type: String,
      required: false
    },
    url: {
      type: String,
      required: false
    },
    title: {
      type: String,
      required: false
    },
    remote_auth_s3: {
      type: String,
      required: false
    },
    api_key: {
      type: String,
      required: false
    },
    sso_config: {
      type: Object,
      required: false
    }
  },
  mounted: function mounted() {
    if (window.DISQUS) {
      this.reset(window.DISQUS);
      return;
    }
    this.init();
  },

  methods: {
    reset: function reset(dsq) {
      var self = this;
      dsq.reset({
        reload: true,
        config: function config() {
          this.page.identifier = self.identifier || self.$route.path || window.location.pathname;
          this.page.url = self.url || self.$el.baseURI;
          if (self.title) {
            this.page.title = self.title;
          }
          if (self.remote_auth_s3) {
            this.page.remote_auth_s3 = self.remote_auth_s3;
          }
          if (self.key) {
            this.page.api_key = self.key;
          }
          if (self.sso_config) {
            this.sso = self.sso_config;
          }
        }
      });
    },
    init: function init() {
      var _this = this;

      var self = this;
      window.disqus_config = function () {
        this.page.identifier = self.identifier || self.$route.path || window.location.pathname;
        this.page.url = self.url || self.$el.baseURI;
        if (self.title) {
          this.page.title = self.title;
        }
        if (self.remote_auth_s3) {
          this.page.remote_auth_s3 = self.remote_auth_s3;
        }
        if (self.api_key) {
          this.page.api_key = self.api_key;
        }
        if (self.sso_config) {
          this.sso = self.sso_config;
        }
      };
      setTimeout(function () {
        var d = document,
            s = d.createElement('script');
        s.type = 'text/javascript';
        s.async = true;
        s.setAttribute('id', 'embed-disqus');
        s.setAttribute('data-timestamp', +new Date());
        s.src = '//' + _this.shortname + '.disqus.com/embed.js';(d.head || d.body).appendChild(s);
      }, 0);
    }
  }
});

/***/ }),

/***/ "ggVv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'blog-nav',
  props: {
    navs: Number,
    content: Object,
    filters: {
      type: Object,
      default: function _default() {}
    }
  },

  computed: {
    labels: function labels() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.filters).map(function (filter) {
        return _this.content.labels[filter];
      });
    }
  },

  methods: {
    navBack: function navBack() {
      if (this.navs && !this.filters.author) this.$router.go(-1);else this.$router.push('/');
    }
  }
});

/***/ }),

/***/ "is/7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_pace_progress__ = __webpack_require__("heTW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_pace_progress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_pace_progress__);


// pace progress bar
__WEBPACK_IMPORTED_MODULE_0_pace_progress___default.a.start();

// use pace hook to know when rendering is ready
__WEBPACK_IMPORTED_MODULE_0_pace_progress___default.a.once('hide', function () {
  window.prerenderReady = true;
});

// Spektrum Media console message
console.info('%c', 'line-height:48px;padding:18px 150px;background:url(\'https://s3-us-west-2.amazonaws.com/s.cdpn.io/450744/vue-snip.svg\') center / contain no-repeat;');

/***/ }),

/***/ "kYEd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BlogFooter_vue__ = __webpack_require__("6Lyb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a388c5c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BlogFooter_vue__ = __webpack_require__("33RP");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BlogFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a388c5c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BlogFooter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "l9gI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"nav"},[_c('h1',{staticClass:"nav__title"},[_c('router-link',{attrs:{"to":"/"}},[_vm._v(_vm._s(_vm.content.title))])],1),_vm._v(" "),_c('transition-group',{staticClass:"nav__menu",attrs:{"tag":"menu","name":"nav__item"}},_vm._l((_vm.labels),function(label){return _c('li',{key:label,staticClass:"nav__item",on:{"click":_vm.navBack}},[_c('i',{staticClass:"nav__item--icon"}),_vm._v(" "),_c('span',{staticClass:"nav__item--label"},[_vm._v(_vm._s(label))])])}))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lb2U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition-group',{staticClass:"blog__feed",attrs:{"tag":"ul","name":_vm.transition}},_vm._l((_vm.feed),function(post){return _c('li',{key:post.id,staticClass:"preview"},[_c('figure',{staticClass:"preview__figure",class:_vm.figureClass,style:(_vm.getBgImg(post.image))},[_c('transition',{attrs:{"name":"v--fade"}},[(!_vm.reading || _vm.$device.phone)?_c('figcaption',{staticClass:"preview__details"},[_c('router-link',{staticClass:"preview__title",attrs:{"to":("/read/" + (post.id))},nativeOn:{"click":function($event){_vm.scrollTo(0, 220, _vm.scrollDelay)}}},[_vm._v("\n            "+_vm._s(post.title)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"preview__meta"},[_c('time',{staticClass:"preview__published"},[_vm._v("\n              "+_vm._s(_vm.prettyDate(post.published))+"\n            ")]),_vm._v(" "),_c('router-link',{staticClass:"preview__author",attrs:{"to":("/by/" + (_vm.kebabify(post.author)))},nativeOn:{"click":function($event){_vm.scrollTo(0, 220, _vm.scrollDelay)}}},[_vm._v("\n              "+_vm._s(post.author)+"\n            ")])],1)],1):_vm._e()])],1)])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lsTR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"disqus_thread"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rcwA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

/* harmony default export */ __webpack_exports__["a"] = ({
  post: function post(id) {
    return {
      path: "/object/" + id,
      resolve: function resolve(response, mappers) {
        var _response$object = response.object,
            title = _response$object.title,
            content = _response$object.content,
            created_at = _response$object.created_at,
            metadata = _response$object.metadata;

        var meta = {
          description: metadata.description,
          published: created_at,
          author: metadata.author.title
        };
        return mappers.merge(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ title: title, content: content }, meta));
      }
    };
  }
});

/***/ }),

/***/ "uJQI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__match_media__ = __webpack_require__("MdQY");



/* harmony default export */ __webpack_exports__["a"] = ({
  install: function install(Vue, queries) {
    var DeviceVM = new Vue({
      data: function data() {
        return {
          devices: {}
        };
      },


      methods: {
        addDevice: function addDevice(name, active) {
          var _this = this;

          this.$set(this.devices, name, active);

          return function (_ref) {
            var matches = _ref.matches;

            _this.devices[name] = matches;
          };
        }
      }
    });

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(queries).forEach(function (name) {
      var query = Object(__WEBPACK_IMPORTED_MODULE_1__match_media__["a" /* default */])('(' + queries[name] + ')');
      var update = DeviceVM.addDevice(name, query.matches);
      query.addListener(update);
    });

    Vue.prototype.$device = DeviceVM.devices;
  }
});

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({ name: 'app' });

/***/ }),

/***/ "xdpD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BlogFeed_vue__ = __webpack_require__("2x06");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_668c591f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BlogFeed_vue__ = __webpack_require__("lb2U");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BlogFeed_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_668c591f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BlogFeed_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "y7Eb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BlogNav_vue__ = __webpack_require__("ggVv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e8819d9c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BlogNav_vue__ = __webpack_require__("l9gI");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BlogNav_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e8819d9c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BlogNav_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.b27b569906050d8b7fcc.js